import { render, staticRenderFns } from "./portfoliocapa.vue?vue&type=template&id=304222da&scoped=true&"
import script from "./portfoliocapa.vue?vue&type=script&lang=js&"
export * from "./portfoliocapa.vue?vue&type=script&lang=js&"
import style0 from "./portfoliocapa.vue?vue&type=style&index=0&id=304222da&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "304222da",
  null
  
)

export default component.exports